/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdibillingProfile.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edibilling-profile";

export class AutogenModelEdibillingProfile<RowType extends ModelRow> extends Endpoint<RowType, RowEdibillingProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdibillingProfile extends ModelRow<RowEdibillingProfileFields> {
	constructor(values?: Partial<RowEdibillingProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdibillingProfileFields {
	ack_xmit_method: string;
	allow_corrections: string;
	allow_xfer_after_settlement: string;
	alt_partner_id: string;
	always_update_stop: string;
	apply_chassis_adds: string;
	apply_container_adds: string;
	apply_ep_adds: string;
	apply_ep_chgs: string;
	apply_ep_dels: string;
	apply_frt_adds: string;
	apply_frt_chgs: string;
	apply_frt_dels: string;
	apply_hdr_adds: string;
	apply_hdr_chgs: string;
	apply_hdr_dels: string;
	apply_move_chgs: string;
	apply_note_adds: string;
	apply_note_dels: string;
	apply_oc_adds: string;
	apply_oc_chgs: string;
	apply_oc_dels: string;
	apply_order_chgs: string;
	apply_refno_adds: string;
	apply_refno_chgs: string;
	apply_refno_dels: string;
	apply_stop_adds: string;
	apply_stop_chgs: string;
	apply_stop_dels: string;
	audit_cutoff_days: number;
	audit_interval: number;
	auto_accept: string;
	auto_compare: string;
	auto_compare_rt: string;
	auto_create_order: string;
	auto_deliver_order: string;
	auto_rate: string;
	carrier_id: string;
	company_id: string;
	compare_update: string;
	days_to_retain: number;
	direction: string;
	edi_comm_id: number;
	enf_batch_cont: string;
	enf_batch_cont_997: string;
	english_printer: string;
	error_options: string;
	error_rpt_printer: string;
	fa_threshold: number;
	filename: string;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	id: string;
	img_def_loc_dir: string;
	img_dir_local: string;
	img_document_types: string;
	img_filetype: string;
	img_required: string;
	individual_batch: string;
	intercompany: string;
	next_batch: number;
	notes: string;
	partner_id: string;
	partner_name: string;
	print_before_send: string;
	print_bills: string;
	process_priority: number;
	purge_rpt_printer: string;
	remove_file: string;
	send_func_ack: string;
	send_to_company: string;
	skip_manual_orders: string;
	special_processing: string;
	st02_format: string;
	template_id: number;
	transaction_set: string;
	transmit_method: string;
	updaterecs_how: string;
	use_master_batch: string;
	use_ok2send: string;
	use_show_as: string;
	version: string;
	zip_filename: string;
	zip_images: string;
}

